const state = () => ({
  classifications: {},
});

const getters = {
  all: (state) => Object.values(state.classifications),
  get: (state) => state.classifications,
};

const mutations = {
  set: function(state, classifications = []) {
    classifications.forEach(classification => {
      state.classifications[classification.id] = classification;
    });
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
